module.exports = __webpack_public_path__ + "img/screen.bbbad058.svg";